export function getConfig() {
    return {
        vapiPublicKey: 'c8c46023-5a86-4a7b-9d8c-2a12c94d81c2',
        vapiAssistantId: '7ecf3f71-6330-4681-9ee8-2aa2a6856e91',
    };
}
